/* NW sengeguide: ingen forudkrydsede tilvalg. Tilfoejet 28-08-2026.

   BAGGRUND: guiden havde lagen.on=true og simple.vaskemiddel=true fra start.
   Brugeren havde altsaa allerede 2 betalte tilvalg valgt uden at roere dem, og
   et bambus dobbeltsaet til 999 kr blev praesenteret som 1.697 kr i bundbjaelken.

   TO GRUNDE TIL AT SLAA DET FRA:
   1) Forbrugeraftalelovens paragraf 31 kraever udtrykkeligt samtykke til ethvert
      tillaegsbeloeb. Samtykke udledt af en standardindstilling taeller ikke.
      Forudkrydsede betalte tilvalg er selve skoleeksemplet.
   2) Det foerste tal brugeren ser efter seks spoergsmaal boer vaere produktets pris.

   Merchandisingen er intakt: badget ANBEFALET staar stadig paa lagenet, og
   tilvalgene ligger stadig oeverst i trin 3. De skal bare vaelges aktivt.

   HVORFOR DET SKER VED RENDER OG IKKE VED INIT: nw-sg-6.js erstatter HELE
   chosen.lagen-objektet naar anbefalingen bygges i goToResult. En default sat
   ved sidevisning eller i resetQuiz bliver derfor kastet vaek igen. Vi vaenter
   derfor til foerste renderResult efter en frisk start, og roerer intet efter det,
   saa brugerens egne til- og fravalg staar ved magt.

   Genoptagelse af en gemt eller delt anbefaling roeres ikke: flaget armeres kun
   af resetQuiz, som netop ikke koeres ved deep-link eller Fortsaet-knappen.

   REVERT: fjern denne fil fra sections/nw-soevnguide.liquid. */
(function(){
  'use strict';

  var armeret = false;
  var hooketReset = false;
  var hooketRender = false;

  function slaaFra(){
    try{
      if(typeof chosen === 'undefined' || !chosen){ return false; }
      if(chosen.lagen){ chosen.lagen.on = false; }
      if(chosen.simple){
        chosen.simple.vaskemiddel = false;
        chosen.simple.vaskepose = false;
        chosen.simple.plaid = false;
      }
      return true;
    }catch(e){ return false; }
  }

  function hookReset(){
    if(hooketReset || typeof window.resetQuiz !== 'function'){ return; }
    hooketReset = true;
    var f = window.resetQuiz;
    window.resetQuiz = function(){
      armeret = true;
      return f.apply(this, arguments);
    };
  }

  function hookRender(){
    if(hooketRender || typeof window.renderResult !== 'function'){ return; }
    hooketRender = true;
    var f = window.renderResult;
    window.renderResult = function(){
      if(armeret){ armeret = false; slaaFra(); }
      return f.apply(this, arguments);
    };
  }

  function kobl(){ hookReset(); hookRender(); }

  kobl();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', kobl); }
  window.addEventListener('load', kobl);
  setTimeout(kobl, 1500);
  setTimeout(kobl, 3500);
})();